export default {"src":"/_next/static/media/harmony-icon.badc98e3.svg","height":34,"width":35,"blurWidth":0,"blurHeight":0};